<template>
  <div
    :id="question.uuid + '-question'"
    class="panel"
    v-if="component_done_loading"
  >
    <!-- v-shortkey.propagte="{
      answer: ['shift', 'a'],
      up: ['arrowup'],
      down: ['arrowdown'],
      enter: ['enter'],
    }"
    @shortkey="questionAccessibility" -->
    <kr-calculator
      v-if="question.type == `openended`"
      ref="calculator"
      :id="question.uuid + '-question-calculator'"
      :canAnswer="canAnswer"
      @answer="appendTempAnswer"
    ></kr-calculator>
    <div class="panel-heading flexSpaceBetween align-items">
      <div>
        <span tabindex="0">
          Question {{ getQuestionNo(question_group_idx, question_idx) }}
        </span>

        <button
          v-if="
            testObj.type == 'trat' &&
              !['not started', 'scheduled'].includes(testObj.status)
          "
          :disabled="
            !isTeamLeader || question.studentAnswer.attempts.length == 0
          "
          class="btn btn-default"
          :class="{ bookmarked: question.studentAnswer.isBookmarked }"
          v-tooltip="{
            content: 'Remind me to seek clarification for this question later',
          }"
          @click="toggleBookmark"
          :aria-label="
            'Bookmark Question ' +
              getQuestionNo(question_group_idx, question_idx)
          "
        >
          <i class="fa fa-bookmark" aria-hidden="true"></i>
        </button>

        <button
          v-if="question.type == `openended`"
          class="btn"
          @click="$refs.calculator.open()"
          aria-label="Open Calculator"
        >
          <i class="fa fa-calculator" aria-hidden="true"></i>
        </button>
      </div>
      <div
        v-if="
          ['mcqs'].includes(question.type) &&
            testObj.settings.confidenceBasedTesting &&
            (!isPreview || isTeacherPreview)
        "
        class="pntRemainining"
      >
        Points Remaining: {{ pointSpreadingPointsLeft }}
      </div>
      <!-- <div v-if="question.attachments&&question.attachments.length!=0">
                <button class="btn btn-default mainBtn" @click="openAttachmentsModal">
                    <i class="fa fa-paperclip"></i>&nbsp;Question Attachment(s)
                </button>
            </div> -->
    </div>
    <div class="panel-body eGallery-panel" :id="question.uuid + '-panel-body'">
      <template v-if="question.type == 'mcqs' || question.type == 'mcqm'">
        <mcq
          :testObj="testObj"
          :question="question"
          :value="tempAnswers[question_group_idx][question_idx]"
          @changed="setTempAnswer"
          :disabled="!canAnswer"
          :isTestCompleted="isTestCompleted"
        ></mcq>
      </template>
      <template v-else-if="['vsa', 'openended'].includes(question.type)">
        <openended
          :testObj="testObj"
          :question="question"
          :value="tempAnswers[question_group_idx][question_idx]"
          @changed="setTempAnswer"
          :disabled="!canAnswer"
          :typing="typing.currentQuestionUuid == question.uuid ? typing : false"
          :isTestCompleted="isTestCompleted"
        ></openended>
      </template>
      <div class="row marginTop20" v-if="canAttach">
        <template v-if="!isTeacherPreview">
          <button
            class="btn btn-primary"
            @click.prevent="addAttachments()"
            :disabled="!canEditComment && !canEditClarification"
            aria-label="Add Attachments"
          >
            Add Attachments
          </button>
        </template>
        <template v-else>
          <button
            class="btn btn-primary"
            v-tooltip="{ content: 'This would open on a real test' }"
            aria-label="Add Attachments"
          >
            Add Attachments
          </button>
        </template>

        <div class="marginBottom20 col-xs-12 col-md-6">
          <div
            class="flex align-items marginTop10"
            v-if="
              question.studentAnswer._attachments &&
                question.studentAnswer._attachments.length != 0
            "
          >
            <div class="col-xs-12">
              <!-- <span style="font-weight:bold;">Uploaded Files</span> -->
              <div
                v-for="(file, idx) in question.studentAnswer._attachments"
                class="flexSpaceBetween"
                :key="idx"
              >
                <div>
                  <span class="marginRight5">{{ idx + 1 }}.&nbsp;</span>
                  <span> <i class="fa fa-file-image-o" aria-hidden="true"></i>&nbsp; </span>
                  <a
                    :href="file.url"
                    target="_blank"
                    download
                    :aria-label="file.filename"
                  >
                    {{ file.filename }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isPreview || isTeacherPreview">
      <!-- <template v-if="question.type == 'mcqs' || question.type == 'mcqm'">
        <div class="unreadChoices" v-if="!reachedTheBottom">
          <div>
            <i class="fas fa-long-arrow-alt-down marginRight10 "></i>More Unread
            Choices<i class="fas fa-long-arrow-alt-down marginLeft10 "></i>
          </div>
        </div>
      </template> -->
      <div class="panel-footer no-print">
        <div class="row flex flexRight">
          <div class="buttonGroup">
            <div class="hidden-xs">
              <div
                v-if="
                  (testObj.type == 'irat' &&
                    testObj.settings.immediateFeedback) ||
                    testObj.type == 'trat'
                "
                class="align-items"
              >
                <div
                  v-if="
                    getQuestionStatus(question_group_idx, question_idx) == 1
                  "
                  class="darkGreen"
                  style="display:block"
                >
                  <i class="fa fa-check-circle marginRight8" aria-hidden="true"></i>Correct answer!

                  <template
                    v-if="
                      testObj.type == 'trat' ||
                        (testObj.type == 'irat' &&
                          testObj.settings.immediateFeedback)
                    "
                  >
                    <template
                      v-if="
                        testObj.settings.enableHintAndExplanation &&
                          question.hintOrExplanation
                      "
                    >
                      <template v-if="question.studentAnswer.isCorrect">
                        <i class="fa fa-trophy marginRight8" aria-hidden="true"></i
                        >
                        <i>{{ question.hintOrExplanation }}</i>
                      </template>
                    </template>
                  </template>
                </div>

                <div
                  v-if="
                    getQuestionStatus(question_group_idx, question_idx) == -1
                  "
                  class="important"
                  style="display:block"
                >
                  <i class="fa fa-info-circle marginRight8" aria-hidden="true"></i>Wrong answer!

                  <template
                    v-if="
                      testObj.type == 'trat' ||
                        (testObj.type == 'irat' &&
                          testObj.settings.immediateFeedback)
                    "
                  >
                    <template
                      v-if="
                        testObj.settings.enableHintAndExplanation &&
                          question.hintOrExplanation
                      "
                    >
                      <template v-if="!question.studentAnswer.isCorrect">
                        <i class="fa fa-commenting fa-flip-horizontal marginRight8" aria-hidden="true"></i
                        >
                        <i>{{ question.hintOrExplanation }}</i>
                      </template>
                    </template>
                  </template>
                </div>
              </div>

              <button
                v-if="canAnswer"
                class="answer-submission btn btn-success"
                :class="{
                  isLoading: isLoading,
                  isSaved: isSaved,
                  isEnabled: canSubmitAnswer,
                }"
                :disabled="!canSubmitAnswer || isLoading || isSaved"
                @click="submitAnswer"
                aria-label="Save Answer"
              >
                <template v-if="!(isSaved || isLoading)">
                  <i class="fa fa-floppy-o marginRight8" aria-hidden="true"></i>Save Answer
                </template>
                <template v-else-if="isLoading">
                  Saving Answer
                  <i
                    class="fa fa-spinner fa-spin marginLeft8"
                    aria-hidden="true"
                  ></i>
                </template>
                <template v-else-if="isSaved">
                  Saved
                  <i class="fa fa-check marginLeft8" aria-hidden="true"></i>
                </template>
              </button>

              <div
                v-if="
                  (testObj.type == 'irat' &&
                    testObj.settings.immediateFeedback) ||
                    testObj.type == 'trat'
                "
                :id="
                  question.type +
                    '-' +
                    getQuestionNo(question_group_idx, question_idx) +
                    '-feedback-update'
                "
                class="visible-hidden"
                aria-live="assertive"
              >
                <template v-if="!isQuestionAnswerChanged">
                  <template
                    v-if="
                      getQuestionStatus(question_group_idx, question_idx) == 1
                    "
                  >
                    Correct Answer! Please proceed to next step

                    <template
                      v-if="
                        testObj.settings.enableHintAndExplanation &&
                          question.hintOrExplanation
                      "
                    >
                      The Hint is {{ question.hintOrExplanation }}
                    </template>
                  </template>

                  <template
                    v-if="
                      getQuestionStatus(question_group_idx, question_idx) === -1
                    "
                  >
                    Wrong answer! Please try again

                    <template
                      v-if="
                        testObj.settings.enableHintAndExplanation &&
                          question.hintOrExplanation
                      "
                    >
                      The Hint is {{ question.hintOrExplanation }}
                    </template>
                  </template>
                </template>
              </div>

              <button
                class="btn btn-primary"
                @click="openClarificationModal"
                v-if="canClarify"
                :aria-label="
                  canEditClarification
                    ? !question.studentAnswer._clarifications
                      ? 'Add Clarification'
                      : 'Edit Clarification'
                    : 'View Clarification'
                "
              >
                <template v-if="canEditClarification">
                  <template v-if="!question.studentAnswer._clarifications">
                    <i class="fas fa-plus marginRight8" aria-hidden="true"></i>Add Clarification
                  </template>
                  <template v-else>
                    <i class="fas fa-edit marginRight8" aria-hidden="true"></i>Edit Clarification
                  </template>
                </template>
                <template v-else>
                  <i class="fas fa-eye marginRight8" aria-hidden="true"></i>View Clarification
                </template>
              </button>

              <button
                v-if="canComment"
                class="btn btn-success"
                @click="openCommentModal"
                :aria-label="
                  canEditComment
                    ? !question.studentAnswer._comments
                      ? 'Add Elaboration'
                      : 'Edit Elaboration'
                    : 'View Elaboration'
                "
              >
                <template v-if="canEditComment">
                  <template v-if="!question.studentAnswer._comments">
                    <i class="fas fa-plus marginRight8" aria-hidden="true"></i>Add Elaboration
                  </template>
                  <template v-else>
                    <i class="fas fa-edit marginRight8" aria-hidden="true"></i>Edit Elaboration
                  </template>
                </template>
                <template v-else>
                  <i class="fas fa-eye marginRight8" aria-hidden="true"></i>View Elaboration
                </template>
              </button>
              <!--<button class="btn btn-success mainBtn" @click="openCommentModal" :disabled="!question.studentAnswer._comments" v-else>
                               
                            </button>-->
              <!--<button v-if="canChangeQuestion(previous_question_group_idx,previous_question_idx)" class="btn btn-default mainBtn" @click="moveToDifferentQuestion(previous_question_group_idx,previous_question_idx)">
                                <i class="fas fa-caret-left"></i>&nbsp;Previous Question
                            </button>
                             <button v-if="canChangeQuestion(next_question_group_idx,next_question_idx)"  class="btn btn-primary mainBtn"  @click="moveToDifferentQuestion(next_question_group_idx,next_question_idx)">
                                Next Question&nbsp;<i class="fas fa-caret-right"></i>
                            </button>-->
              <!-- <button v-if="!isTestCompleted" class="btn btn-success mainBtn" :disabled="isSubmitTestButtonDisabled" @click.prevent="submitTest">
                                <i class="fas fa-check"></i>&nbsp;Submit Test
                            </button> -->
            </div>
            <div class="hidden-sm hidden-md hidden-lg">
              <button
                class="answer-submission btn btn-success"
                :class="{
                  isLoading: isLoading,
                  isSaved: isSaved,
                  isEnabled: canSubmitAnswer,
                }"
                :disabled="!canSubmitAnswer"
                @click="submitAnswer"
                v-if="canAnswer"
                aria-label="Save Answer"
              >
                <i class="fa fa-floppy-o marginRight8" aria-hidden="true"></i
                >Save Answer
              </button>
              <button
                class="btn btn-primary"
                @click="openClarificationModal"
                v-if="canClarify"
                aria-label="Add/Edit/View Clarification"
              >
                <template v-if="canEditClarification">
                  <template v-if="!question.studentAnswer._clarifications"
                    ><i class="fas fa-plus marginRight8" aria-hidden="true"></i>Clarification</template
                  >
                  <template v-else
                    ><i class="fas fa-edit marginRight8" aria-hidden="true"></i>Clarification</template
                  >
                </template>
                <template v-else
                  ><i class="fas fa-eye marginRight8" aria-hidden="true"></i>Clarification</template
                >
              </button>
              <button
                class="btn btn-success"
                @click="openCommentModal"
                v-if="canComment"
                aria-label="Add/Edit/View Elaboration"
              >
                <template v-if="canEditComment">
                  <template v-if="!question.studentAnswer._comments">
                    <i class="fas fa-plus marginRight8" aria-hidden="true"></i>Add Elaboration
                  </template>
                  <template v-else>
                    <i class="fas fa-edit marginRight8" aria-hidden="true"></i>Edit Elaboration
                  </template>
                </template>
                <template v-else>
                  <i class="fas fa-eye marginRight8" aria-hidden="true"></i>View Elaboration
                </template>
              </button>
              <!--<button class="btn btn-success mainBtn" @click="openCommentModal" :disabled="!question.studentAnswer._comments" v-else>
                                
                            </button>-->
              <!--<button v-if="canChangeQuestion(previous_question_group_idx,previous_question_idx)" class="btn btn-default mainBtn" @click="moveToDifferentQuestion(previous_question_group_idx,previous_question_idx)">
                                <i class="fas fa-caret-left"></i>
                            </button>
                             <button v-if="canChangeQuestion(next_question_group_idx,next_question_idx)"  class="btn btn-primary mainBtn"  @click="moveToDifferentQuestion(next_question_group_idx,next_question_idx)">
                                <i class="fas fa-caret-right"></i>
                            </button> -->
              <!--<button v-if="!isTestCompleted" class="btn btn-success mainBtn" :disabled="isSubmitTestButtonDisabled" @click.prevent="submitTest">
                                <i class="fas fa-check"></i>
                            </button>-->
            </div>
          </div>
        </div>

        <div
          v-if="
            !testObj._isPreview &&
              canAllowChangeAnswers &&
              isQuestionAnswerChanged &&
              canSubmitAnswer &&
              question.studentAnswer.attempts != 0 &&
              testObj.type != 'trat'
          "
          class="alert alert-danger marginTop20"
          role="alert"
        >
          <i class="fa fa-info-circle marginTop2"></i>Changed your answer? Don't
          forget to save it!
        </div>

        <div class="hidden-sm hidden-md hidden-lg">
          <div
            v-if="
              (testObj.type == 'irat' && testObj.settings.immediateFeedback) ||
                testObj.type == 'trat'
            "
            class="marginTop10"
          >
            <div
              v-if="getQuestionStatus(question_group_idx, question_idx) == 1"
              class="darkGreen"
            >
              <i class="fa fa-check-circle marginRight8" aria-hidden="true"></i>Correct answer!

              <template
                v-if="
                  testObj.type == 'trat' ||
                    (testObj.type == 'irat' &&
                      testObj.settings.immediateFeedback)
                "
              >
                <template
                  v-if="
                    testObj.settings.enableHintAndExplanation &&
                      question.hintOrExplanation
                  "
                >
                  <template v-if="question.studentAnswer.isCorrect">
                    <i class="fa fa-trophy marginRight8" aria-hidden="true"></i>
                    {{ question.hintOrExplanation }}
                  </template>
                </template>
              </template>
            </div>
            <div
              v-if="getQuestionStatus(question_group_idx, question_idx) == -1"
              class="important"
            >
              <i class="fa fa-info-circle marginRight8" aria-hidden="true"></i>Wrong answer!

              <template
                v-if="
                  testObj.type == 'trat' ||
                    (testObj.type == 'irat' &&
                      testObj.settings.immediateFeedback)
                "
              >
                <template
                  v-if="
                    testObj.settings.enableHintAndExplanation &&
                      question.hintOrExplanation
                  "
                >
                  <template v-if="!question.studentAnswer.isCorrect">
                    <i class="fa fa-commenting fa-flip-horizontal marginRight8" aria-hidden="true"></i
                    >
                    {{ question.hintOrExplanation }}
                  </template>
                </template>
              </template>
            </div>
          </div>
        </div>
        <!-- <template
          v-if="
            testObj.type == 'trat' ||
              (testObj.type == 'irat' && testObj.settings.immediateFeedback)
          "
        >
          <template
            v-if="
              testObj.settings.enableHintAndExplanation &&
                question.hintOrExplanation
            "
          >
            <template v-if="question.studentAnswer.isCorrect">
              <div class="successColor">
                <i class="fa fa-check-circle"></i>&nbsp;Explanation!
                {{ question.hintOrExplanation }}
              </div>
            </template>
            <template v-else>
              <div class="errorColor">
                <i class="fa fa-info-circle"></i>&nbsp;Hint:
                {{ question.hintOrExplanation }}
              </div>
            </template>
          </template>
        </template> -->
      </div>
    </div>
    <div
      class="modal"
      :id="question.uuid + '-clarification-modal'"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'clarificationModal-' + question.uuid + '-title'"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h4
              :id="'clarificationModal-' + question.uuid + '-title'"
              class="modal-title"
            >
              Clarify This Question
            </h4>
          </div>
          <div class="modal-body">
            We would like to clarify …
            <div class="row">
              <textarea
                v-model="question.studentAnswer._clarifications"
                rows="5"
                cols="3"
                class="form-control"
                placeholder="Type clarification here…"
                :disabled="!canEditClarification"
                aria-label="We would like to clarify"
              />
            </div>
            <div class="row" style="margin-top:10px">
              <div class="buttonGroup">
                <button
                  class="btn btn-primary"
                  :disabled="!canSubmitClarifications"
                  @click.prevent="submitClarifications()"
                  aria-label="Save Clarification"
                >
                  Save Clarification
                </button>
                <button
                  class="btn btn-default"
                  data-dismiss="modal"
                  aria-label="Back"
                >
                  <i class="fa fa-caret-left marginRight8" aria-hidden="true"></i>Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      :id="question.uuid + '-comment-modal'"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'commentModal-' + question.uuid + '-title'"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h4
              :id="'commentModal-' + question.uuid + '-title'"
              class="modal-title"
            >
              Elaborate
            </h4>
          </div>
          <div class="modal-body">
            We would like to elaborate...
            <div class="row">
              <textarea
                v-model="question.studentAnswer._comments"
                rows="5"
                cols="3"
                class="form-control"
                placeholder="Type comments here…"
                :disabled="!canEditComment"
                aria-label="We would like to elaborate"
              />
            </div>
            <div class="row" style="margin-top:10px">
              <div class="buttonGroup">
                <button
                  class="btn btn-success"
                  :disabled="!canSubmitComments"
                  @click.prevent="submitComments()"
                  aria-label="Save Elaboration"
                >
                  Save Elaboration
                </button>
                <button
                  class="btn btn-default"
                  data-dismiss="modal"
                  aria-label="Back"
                >
                  <i class="fa fa-caret-left marginRight8" aria-hidden="true"></i>Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      :id="question.uuid + '-attachments-modal'"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'attachmentsModal-' + question.uuid + '-title'"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h4
              :id="'attachmentsModal-' + question.uuid + '-title'"
              class="modal-title"
            >
              Teacher’s Attachment(s)
            </h4>
          </div>
          <div class="modal-body">
            <div class="col-xs-12 col-md-6">
              <div
                class="flex align-items"
                v-if="question.attachments && question.attachments.length != 0"
              >
                <div class="col-xs-12">
                  <!-- <span style="font-weight:bold;">Uploaded Files</span> -->
                  <div
                    v-for="(file, idx) in question.attachments"
                    class="flexSpaceBetween attachedFiles"
                    :key="idx"
                  >
                    <div>
                      <span>{{ idx + 1 }}.</span>
                      <span>
                        <i class="fa fa-file-image-o" aria-hidden="true"></i>
                      </span>
                      <template v-if="isPdf(file)">
                        <template v-if="testObj.settings.allowPdfDownload">
                          <a
                            :href="file.url"
                            target="_blank"
                            download
                            :aria-label="file.filename"
                            >{{ file.filename }}</a
                          >
                        </template>
                        <template v-else>
                          <a
                            @click.prevent="openViewPdfModal(file)"
                            :aria-label="file.filename"
                            >{{ file.filename }}</a
                          >
                        </template>
                      </template>
                      <template v-else>
                        <a
                          :href="file.url"
                          target="_blank"
                          download
                          :aria-label="file.filename"
                          >{{ file.filename }}</a
                        >
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <template v-else>
                <div>-</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal modal-manual"
      :id="question.uuid + '-enlarge-image-modal'"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'enlargeImageModal-' + question.uuid + '-title'"
      data-keyboard="false"
      data-backdrop="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
            
            <h4
              :id="'enlargeImageModal-' + question.uuid + '-title'"
              class="modal-title"
            >
              <i class="fa fa-arrows marginRight8" aria-hidden="true"></i>Enlarged
              Image
            </h4>
          </div>
          <div class="modal-body padding0">
            <img :src="srcValue" :key="srcValue" width="100%" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { testMixins } from "./../../../../../../../mixins/test";
import KrAuth from "../../../../../../../components/auth/auth";
import * as filestack from "filestack-js";
export default {
  props: [
    "testObj",
    "question",
    "question_group_idx",
    "question_idx",
    "tempAnswers",
    "typing",
    "sharedObj",
  ],
  mixins: [testMixins],
  components: {
    mcq: require(`./partials/mcq.vue`).default,
    openended: require(`./partials/openended.vue`).default,
  },
  data() {
    var that = this;
    var auth = new KrAuth();
    var debounceLiveTyping = _.debounce(
      function(tempAnswer) {
        window.Echo.join(
          `test.${that.testObj.testUuid}.team.${that.testObj.teamUuid}`
        ).whisper("typing", {
          user: {
            uuid: auth.user().uuid,
            displayName: auth.user().displayName,
          },
          currentQuestionUuid: that.question.uuid,
          answer: tempAnswer,
        });
      },
      1000,
      { maxWait: 2000 }
    );
    return {
      auth: auth,
      component_done_loading: false,
      clarifications: null,
      comments: null,
      attachments: [],
      client: filestack.init(process.env.VUE_APP_FILESTACK_API_KEY), //filestack client
      accessibility: {
        currOption: false,
        testSubmissionBtnOption: false,
      },
      reachedTheBottom: false,
      scrollFunction: null,
      debounceLiveTyping: debounceLiveTyping,
      attachment: null,
      isLoading: false,
      isSaved: false,
      srcValue: "",
    };
  },
  created() {
    var that = this;
    this.scrollFunction = function() {
      if (!["mcqm", "mcqs"].includes(this.question.type)) {
        return;
      }
      let option = this.question.options[this.question.options.length - 1];
      if (
        this.isScrolledIntoView(
          "#" + this.question.uuid + "-" + option.key + "-div"
        )
      ) {
        this.reachedTheBottom = true;
      }
    }.bind(this);

    this.component_done_loading = true;
    //this.init();

    Vue.nextTick(function() {
      that.scrollFunction();
      $("#" + that.question.uuid + "-enlarge-image-modal").draggable();
    });
  },
  mounted() {
    window.addEventListener("click", (event) => {
      const isImg = event.target.nodeName === "IMG";
      if (!isImg) {
        return;
      }
      var questionUUID = event.target
        .closest(".panel")
        .getAttribute("id")
        .slice(0, 36);
      this.openEnlargeImageModal(event.target.src, questionUUID);
    });

    window.addEventListener("scroll", this.scrollFunction);
  },
  beforeDestroy() {
    window.removeEventListener("click", (event) => {
      const isImg = event.target.nodeName === "IMG";
      if (!isImg) {
        return;
      }

      var questionUUID = event.target
        .closest(".panel")
        .getAttribute("id")
        .slice(0, 36);
      this.openEnlargeImageModal(event.target.src, questionUUID);
    });

    window.removeEventListener("scroll", this.scrollFunction);
  },
  methods: {
    // questionAccessibility(event) {
    //   if (this.testObj.questions[this.question_group_idx].length > 1) {
    //     return;
    //   }
    //   if (this.testObj.type == "application") {
    //     return;
    //   }
    //   if (($("#test_confirm_modal").data("bs.modal") || {}).isShown) {
    //     return;
    //   }
    //   if (
    //     ($("#" + this.question.uuid + "-comment-modal").data("bs.modal") || {})
    //       .isShown
    //   ) {
    //     return;
    //   }
    //   if (
    //     (
    //       $("#" + this.question.uuid + "-clarification-modal").data(
    //         "bs.modal"
    //       ) || {}
    //     ).isShown
    //   ) {
    //     return;
    //   }
    //   var that = this;
    //   let options = _.clone(that.question.options);
    //   options.push({ key: "answer", enabled: true });
    //   options.push({ key: "test", enabled: true });
    //   switch (event.srcKey) {
    //     case "answer":
    //       if (that.canSubmitAnswer) {
    //         that.submitAnswer();
    //       }
    //       break;
    //     case "enter":
    //       let currIdx = Math.abs(
    //         that.accessibility.currOption % options.length
    //       );
    //       let key = options[currIdx].key;
    //       if (key == "answer") {
    //         if (
    //           (that.question.type == "openended" &&
    //             !$("#" + that.question.uuid + "-" + "openended").is(
    //               ":focus"
    //             )) ||
    //           that.question.type != "openended"
    //         ) {
    //           that.submitAnswer();
    //         }
    //       } else if (key == "test") {
    //         Events.fire("submit-test");
    //       } else {
    //         if (that.question.type != "mcqm") {
    //           that.tempAnswers[that.question_group_idx][
    //             that.question_idx
    //           ] = key;
    //           that.tempAnswers.splice();
    //         }
    //       }
    //       break;
    //     case "up":
    //     case "down":
    //       let bias = 0;
    //       if (that.accessibility.currOption === false) {
    //         bias = 0;
    //         that.accessibility.currOption = 0;
    //       } else if (event.srcKey == "up") {
    //         bias = -1;
    //       } else if (event.srcKey == "down") {
    //         bias = 1;
    //       }
    //       let routine = function(bias) {
    //         let answer_submit_buttons = $("button.answer-submission");
    //         let test_submit_buttons = $("button.test-submission");
    //         that.accessibility.currOption += bias;
    //         let currIdx = Math.abs(
    //           that.accessibility.currOption % options.length
    //         );
    //         let key = options[currIdx].key;
    //         for (var i = 0; i < answer_submit_buttons.length; i++) {
    //           $(answer_submit_buttons[i]).removeClass("selected");
    //         }
    //         for (var i = 0; i < test_submit_buttons.length; i++) {
    //           $(test_submit_buttons[i]).removeClass("selected");
    //         }
    //         if (key != "answer" && key != "test") {
    //           if (!["mcqs", "mcqm"].includes(that.question.type)) {
    //             return;
    //           }
    //           for (var i = 0; i < that.question.options.length; i++) {
    //             that.question.options[i].highlight = i === currIdx;

    //             if (that.question.options[i].highlight) {
    //               if (
    //                 $(
    //                   "#" +
    //                     that.question.uuid +
    //                     "-" +
    //                     that.question.options[i].key +
    //                     "-div"
    //                 )
    //               ) {
    //                 if (
    //                   $(
    //                     "#" +
    //                       that.question.uuid +
    //                       "-" +
    //                       that.question.options[i].key +
    //                       "-div"
    //                   ) != undefined
    //                 ) {
    //                   var offset = $(
    //                     "#" +
    //                       that.question.uuid +
    //                       "-" +
    //                       that.question.options[i].key +
    //                       "-div"
    //                   ).offset().top;
    //                   Vue.nextTick(function() {
    //                     $([document.documentElement, document.body]).animate(
    //                       {
    //                         scrollTop: offset - 200,
    //                       },
    //                       200
    //                     );
    //                   });
    //                 }
    //               }
    //             }
    //             that.question.options.splice();
    //           }
    //         } else {
    //           if (key == "answer") {
    //             if (answer_submit_buttons.length == 0) {
    //               routine(bias);
    //               return;
    //             }
    //             for (var i = 0; i < answer_submit_buttons.length; i++) {
    //               if (!$(answer_submit_buttons[i]).prop("disabled")) {
    //                 $(answer_submit_buttons[i]).addClass("selected");
    //               } else {
    //                 routine(bias);
    //                 return;
    //               }
    //             }
    //           }
    //           if (key == "test") {
    //             if (test_submit_buttons.length == 0) {
    //               routine(bias);
    //               return;
    //             }
    //             for (var i = 0; i < test_submit_buttons.length; i++) {
    //               if (!$(test_submit_buttons[i]).prop("disabled")) {
    //                 $(test_submit_buttons[i]).addClass("selected");
    //               } else {
    //                 routine(bias);
    //                 return;
    //               }
    //             }
    //           }
    //         }
    //       };
    //       routine(bias);
    //       break;
    //   }
    // },
    toggleBookmark() {
      /*if(_.isEmpty(_.get(this.question,'studentAnswer.isBookmarked'))){
                return false;
            }*/
      var that = this;
      Vue.set(
        that.question.studentAnswer,
        "isBookmarked",
        !that.question.studentAnswer.isBookmarked
      );
      axios
        .post("student/tests/bookmark", {
          userPlacementTestUuid: this.testObj.uuid,
          activityQuestionUuid: this.question.uuid,
        })
        .then(function(response) {
          that.$notify({
            group: "form",
            type: "success",
            title: "Success",
            text:
              "Question is now" +
              (that.question.studentAnswer.isBookmarked
                ? " remembered"
                : " forgotten."),
          });
        })
        .catch(function(errors) {
          Vue.set(
            that.question.studentAnswer,
            "isBookmarked",
            !that.question.studentAnswer.isBookmarked
          );
          that.$notify({
            group: "form",
            type: "error",
            title: "Error",
            text:
              "Unable to show question statistics at this moment, please try again later",
          });
        });
    },
    /*submitTest(){
            Events.fire('submit-test');
        },*/
    addAttachments() {
      var that = this;
      this.client
        .picker({
          accept: [
            ".jpg",
            ".jpeg",
            ".gif",
            ".png",
            ".csv",
            ".doc",
            ".docx",
            ".dot",
            ".dotx",
            ".key",
            ".numbers",
            ".odt",
            ".odp",
            ".ods",
            ".pages",
            ".pdf",
            ".ppt",
            ".pot",
            ".potx",
            ".pps",
            ".ppsx",
            ".pub",
            ".rtf",
            ".sldx",
            ".txt",
            ".xls",
            ".xlt",
            ".xlsx",
            ".mp4",
            ".mp3",
            ".rmd",
          ],
          maxFiles: 20,
          uploadInBackground: false,
          onUploadStarted: function(file) {
            //that.is_uploading = true;
          },
          onUploadDone: function(res) {
            //that.is_uploading = false;
            let currentLength = _.get(
              that,
              "question.studentAnswer._attachments",
              []
            ).length;
            for (var i = 0; i < res.filesUploaded.length; i++) {
              _.set(
                that.question.studentAnswer._attachments,
                currentLength++,
                res.filesUploaded[i]
              );
            }
            that.question.studentAnswer._attachments.splice();
            that.submitAttachments();
          },
        })
        .open();
    },
    submitClarifications() {
      var that = this;
      if (this.isTeacherPreview) {
        this.question.studentAnswer.clarifications = this.question.studentAnswer._clarifications;
        return;
      }
      axios
        .post(`/student/tests/${this.testObj.uuid}/clarifications`, {
          activityQuestionUuid: this.question.uuid,
          clarifications: this.question.studentAnswer._clarifications,
        })
        .then(function(response) {
          $("#" + that.question.uuid + "-clarification-modal").modal("hide");
          that.$notify({
            group: "form",
            type: "success",
            title: "Success",
            text: "You have successfully sent clarifications for this question",
          });
          //Events.fire('changed-test',response.data.data);
        });
    },
    submitComments() {
      var that = this;
      if (this.isTeacherPreview) {
        this.question.studentAnswer.comments = this.question.studentAnswer._comments;
        return;
      }
      axios
        .post(`/student/tests/${this.testObj.uuid}/elaborations`, {
          activityQuestionUuid: this.question.uuid,
          comments: this.question.studentAnswer._comments,
        })
        .then(function(response) {
          $("#" + that.question.uuid + "-comment-modal").modal("hide");
          that.$notify({
            group: "form",
            type: "success",
            title: "Success",
            text: "You have successfully sent elaborations for this question",
          });
          // Events.fire('changed-test',response.data.data);
        });
    },
    submitAttachments() {
      var that = this;
      var url = this.canClarify
        ? `/student/tests/${this.testObj.uuid}/clarifications`
        : this.canComment
        ? `/student/tests/${this.testObj.uuid}/elaborations`
        : false;
      if (!url) {
        //console.log('cannot submit attachment')
        return false;
      }
      axios
        .post(url, {
          activityQuestionUuid: this.question.uuid,
          attachments: this.question.studentAnswer._attachments,
        })
        .then(function(response) {
          that.$notify({
            group: "form",
            type: "success",
            title: "Success",
            text: "You have successfully sent attachment/s for this question",
          });
          // Events.fire('changed-test',response.data.data);
        });
    },
    submitAnswer() {
      var that = this;

      this.isLoading = true;
      window.setTimeout(function() {
        that.isLoading = false;
        that.isSaved = true;

        window.setTimeout(function() {
          that.isSaved = false;

          that.$emit("submitAnswer", {
            question_group_idx: that.question_group_idx,
            question_idx: that.question_idx,
          });
        }, 500);
      }, 500);
    },
    appendTempAnswer(answer) {
      answer =
        _.get(
          this.tempAnswers[this.question_group_idx],
          this.question_idx,
          ""
        ) + answer;
      Vue.set(
        this.tempAnswers[this.question_group_idx],
        this.question_idx,
        answer
      );
    },
    setTempAnswer(tempAnswer) {
      var that = this;
      if (this.question.type == "openended" && this.isTeamLeader) {
        this.debounceLiveTyping(tempAnswer);
      }
      Vue.set(
        this.tempAnswers[this.question_group_idx],
        this.question_idx,
        tempAnswer
      );
      /*if(this.testObj.type=='irat'){
                this.submitAnswer();
            }*/
    },
    init() {
      this.client = filestack.init(process.env.VUE_APP_FILESTACK_API_KEY);
      //this.question = this.testObj.questions[this.question_group_idx][this.question_idx];
    },
    openAttachmentsModal() {
      $("#" + this.question.uuid + "-attachments-modal").modal("show");
    },
    openClarificationModal() {
      $("#" + this.question.uuid + "-clarification-modal").modal("show");
    },
    openCommentModal() {
      $("#" + this.question.uuid + "-comment-modal").modal("show");
    },
    isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top + 90;
      var elemBottom = elemTop + $(elem).height();

      // console.log("docViewBottom " + docViewBottom);

      // console.log("elemTop " + elemTop);
      // console.log("elemBottom " + elemBottom);

      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    openViewPdfModal(attachment) {
      Events.fire("view-pdf-modal", attachment, {
        canDownload: this.testObj.settings.allowPdfDownload,
      });
    },
    openEnlargeImageModal(src, id) {
      if (id == this.question.uuid) {
        $("#" + this.question.uuid + "-enlarge-image-modal").modal("show");

        this.srcValue = src;
        $(
          "#" + this.question.uuid + "-enlarge-image-modal"
        ).resizable({
          handles: 'ne, se, sw, nw'
        });
      }
    },
  },
  computed: {
    isQuestionAnswerChanged() {
      let attempts = _.get(this.question, "studentAnswer.attempts", []);
      let storedAnswer = -1;
      if (attempts.length != 0) {
        storedAnswer = attempts[attempts.length - 1];
        if (this.testObj.settings.randomizeAnswerOptionOrder) {
          storedAnswer = _.find(this.question.options, function(o) {
            return o.originalKey == storedAnswer;
          });
          if (storedAnswer) {
            storedAnswer = storedAnswer.key;
          }
        }
      }
      if (this.tempAnswers[this.question_group_idx][this.question_idx] == "") {
        return false;
      }

      return !_.isEqual(
        this.tempAnswers[this.question_group_idx][this.question_idx],
        storedAnswer
      );
    },
    /*isSubmitTestButtonDisabled(){
            return this.total_questions!=this.answered_count||(this.testObj.type=='trat'&&!this.isTeamLeader)||(this.testObj.type=='application'&&this.testObj.others.applicationType=='team'&&!this.isTeamLeader);
        },*/
    canAllowChangeAnswers() {
      return _.get(
        this.testObj,
        "settings.allowChangeAnswersBeforeFinalSubmission",
        true
      );
    },
    canComment() {
      if (this.testObj.type == "application" && !this.isTestCompleted) {
        return true;
      }
      return false;
    },
    canEditComment() {
      if (!this.canComment) {
        return false;
      }
      if (
        (this.testObj.others.applicationType == "team" && this.isTeamLeader) ||
        this.testObj.others.applicationType == "individual"
      ) {
        return true;
      }
      return false;
    },
    canSubmitComments() {
      let comments = _.get(this.question, "studentAnswer.comments", "");
      let attachments = _.get(this.question, "studentAnswer.attachments", []);
      if (!attachments) {
        attachments = [];
      }
      if (
        this.question.studentAnswer._comments == comments &&
        _.isEqual(attachments, this.question.studentAnswer._attachments)
      ) {
        return false;
      }
      if (!this.canComment || !this.canEditComment) {
        return false;
      }
      return true;
    },
    canClarify() {
      if (
        this.testObj.type == "trat" &&
        this.testObj.settings.allowTeamClarifications
      ) {
        return true;
      }
      return false;
    },
    canEditClarification() {
      if (
        !["paused", "stopped", "released"].includes(
          this.testObj.clarificationStatus
        ) &&
        this.isTeamLeader
      ) {
        return true;
      }
      return false;
    },
    canSubmitClarifications() {
      let clarifications = _.get(
        this.question,
        "studentAnswer.clarifications",
        ""
      );
      let attachments = _.get(this.question, "studentAnswer.attachments", []);
      if (!attachments) {
        attachments = [];
      }
      if (
        this.question.studentAnswer._clarifications == clarifications &&
        _.isEqual(attachments, this.question.studentAnswer._attachments)
      ) {
        return false;
      }
      if (!this.canClarify || !this.canEditClarification) {
        return false;
      }
      return true;
    },
    canAnswer() {
      if (this.isTestCompleted || this.sharedObj.isFormBusy) {
        return false;
      }
      let attempts = _.get(this.question, "studentAnswer.attempts", []);
      let storedAnswer = -1;
      if (attempts.length != 0) {
        storedAnswer = attempts[attempts.length - 1];
      }
      if (
        this.testObj.type == "irat" &&
        !_.get(this.testObj, "settings.immediateFeedback")
      ) {
        if (!this.canAllowChangeAnswers && storedAnswer != -1) {
          return false;
        }
      }
      if (
        this.testObj.type == "trat" ||
        (this.testObj.type == "irat" &&
          _.get(this.testObj, "settings.immediateFeedback"))
      ) {
        let isCorrect = _.get(this.question, "studentAnswer.isCorrect", false);
        if (isCorrect) {
          return false;
        }
        if (!this.isTeamLeader && this.testObj.type == "trat") {
          return false;
        }
      }
      if (this.testObj.type == "application") {
        if (!this.canAllowChangeAnswers && storedAnswer != -1) {
          return false;
        }
        if (this.testObj.others.applicationType == "team") {
          if (!this.isTeamLeader) {
            return false;
          }
        }
      }
      return true;
    },
    canSubmitAnswer() {
      if (
        this.testObj.type == "irat" &&
        this.testObj.settings.immediateFeedback
      ) {
        let isCorrect = _.get(this.question, "studentAnswer.isCorrect", false);
        if (isCorrect) {
          return false;
        } else {
          if (this.question.type == "mcqs") {
            if (
              this.tempAnswers[this.question_group_idx][this.question_idx] == ""
            ) {
              return false;
            }
          }
          if (
            !_.isEqual(
              this.tempAnswers[this.question_group_idx][this.question_idx],
              storedAnswer
            )
          ) {
            if (
              this.tempAnswers[this.question_group_idx][this.question_idx] != ""
            ) {
              return true;
            }
          }
        }
      }

      if (this.isTestCompleted || this.sharedObj.isFormBusy) {
        return false;
      }
      let attempts = _.get(this.question, "studentAnswer.attempts", []);
      let storedAnswer = -1;
      if (attempts.length != 0) {
        storedAnswer = attempts[attempts.length - 1];
      }

      if (this.testObj.type == "irat" || this.testObj.type == "application") {
        if (
          this.testObj.type == "application" &&
          this.testObj.others.applicationType == "team"
        ) {
          if (!this.isTeamLeader) {
            return false;
          }
        }
        if (!this.canAllowChangeAnswers && storedAnswer != -1) {
          return false;
        } else if (
          this.testObj.settings.confidenceBasedTesting &&
          ["mcqs"].includes(this.question.type)
        ) {
          //console.log(this.tempAnswers[this.question_group_idx][this.question_idx]);
          //console.log(storedAnswer);
          let cloneTempAnswers = _.cloneDeep(
            this.tempAnswers[this.question_group_idx][this.question_idx]
          );
          if (this.testObj.settings.randomizeAnswerOptionOrder) {
            for (var z = 0; z < this.question.options.length; z++) {
              cloneTempAnswers[
                this.question.options[z].originalKey
              ] = this.tempAnswers[this.question_group_idx][this.question_idx][
                this.question.options[z].key
              ];
            }
          }
          if (
            this.pointSpreadingPointsLeft == 0 &&
            !_.isEqual(cloneTempAnswers, storedAnswer)
          ) {
            return true;
          }
        } else if (this.question.type == "mcqm") {
          if (
            this.tempAnswers[this.question_group_idx][this.question_idx]
              .length != 0
          ) {
            if (
              !_.isEqual(
                this.tempAnswers[this.question_group_idx][this.question_idx],
                storedAnswer
              )
            ) {
              return true;
            }
          }
        } else if (["mcqs", "openended", "vsa"].includes(this.question.type)) {
          if (
            this.tempAnswers[this.question_group_idx][this.question_idx] != ""
          ) {
            //randomize question orders
            if (this.testObj.type == "irat") {
              if (this.testObj.settings.randomizeAnswerOptionOrder) {
                storedAnswer = _.find(this.question.options, function(o) {
                  return o.originalKey == storedAnswer;
                });
                if (storedAnswer) {
                  storedAnswer = storedAnswer.key;
                }
              }

              if (
                !_.isEqual(
                  this.tempAnswers[this.question_group_idx][this.question_idx],
                  storedAnswer
                )
              ) {
                return true;
              }
            }
            if (["vsa", "openended"].includes(this.question.type)) {
              if (this.tempAnswers[this.question_group_idx][this.question_idx])
                var length =
                  this.tempAnswers[this.question_group_idx][
                    this.question_idx
                  ].split(/[^\s]+/).length - 1;
              if (this.question.minimum > length) {
                return false;
              }
              if (this.question.maximum && this.question.maximum < length) {
                return false;
              }
            }
            if (this.isQuestionAnswerChanged) {
              return true;
            }
          }
        }
      }
      if (this.testObj.type == "trat") {
        if (!this.isTeamLeader) {
          return false;
        } else {
          if (["mcqs", "mcqm"].includes(this.question.type)) {
            let isCorrect = _.get(
              this.question,
              "studentAnswer.isCorrect",
              false
            );
            if (isCorrect) {
              return false;
            } else {
              if (this.question.type == "mcqm") {
                if (
                  this.tempAnswers[this.question_group_idx][this.question_idx]
                    .length == 0
                ) {
                  return false;
                }
              }
              if (this.question.type == "mcqs") {
                if (
                  this.tempAnswers[this.question_group_idx][
                    this.question_idx
                  ] == ""
                ) {
                  return false;
                }
              }
              if (
                !_.isEqual(
                  this.tempAnswers[this.question_group_idx][this.question_idx],
                  storedAnswer
                )
              ) {
                if (this.question.type == "mcqs") {
                  if (
                    this.tempAnswers[this.question_group_idx][
                      this.question_idx
                    ] != ""
                  ) {
                    return true;
                  }
                }
                if (this.question.type == "mcqm") {
                  if (
                    this.tempAnswers[this.question_group_idx][this.question_idx]
                      .length > 0
                  ) {
                    return true;
                  }
                }
              }
            }
          }
        }
      }
      return false;
    },
    canAttach() {
      if (this.testObj.type == "irat" || this.auth.user().role=='demo') {
        return false;
      }
      return _.get(this.testObj, "settings.allowStudentsToUploadFiles", false);
    },
    isLastQuestion() {
      if (
        this.question_group_idx == this.testObj.questions.length - 1 &&
        this.question_idx ==
          this.testObj.questions[this.question_group_idx].length - 1
      ) {
        return true;
      }
      return false;
    },
    pointSpreadingPointsLeft() {
      if (!this.testObj.settings.confidenceBasedTesting) {
        return null;
      }
      let total = this.question.options.length;
      //return total;
      var that = this;
      Object.keys(
        this.tempAnswers[this.question_group_idx][this.question_idx]
      ).forEach(function(key, index) {
        total -= parseInt(
          that.tempAnswers[that.question_group_idx][that.question_idx][key]
        );
      });
      return total;
    },
  },
};
</script>

<style>
.panel-footer-sticky {
  position: sticky;
  bottom: 36px;
  z-index: 5;
}

@media screen and (max-height: 800px) {
  .panel-footer {
    position: inherit;
  }
}

@media (max-width: 991px) {
  .group .panel-footer {
    bottom: 47px;
  }
}
</style>

<style scoped>
.pntRemainining {
  color: #989b9c;
  font-weight: bold;
  text-transform: capitalize;
}
.bookmarked i.fa-bookmark {
  color: #facd36;
}

.attachedFiles {
  margin-bottom: 20px;
}

.attachedFiles:last-child {
  margin-bottom: 0;
}

.unreadChoices {
  display: flex;
  justify-content: center;
  padding: 10px;
}

.unreadChoices div {
  text-align: center;
  padding: 6px 12px;
  border-radius: 25px;
  text-transform: uppercase;
  background: #c5d0de;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
}
</style>
